export const TimelineIcon = ({ activeColor }) => {
  return (
    <svg width="24" height="24" viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg">
      <path fill={activeColor} d="M31.3738 7.29289c.3905.39053.3905 1.02369 0 1.41422L18.7071 21.3738c-.1875.1875-.4418.2929-.7071.2929-.2652 0-.5195-.1054-.7071-.2929l-5.9595-5.9596-9.29292 9.2929c-.39052.3905-1.02369.3905-1.414213 0-.390524-.3905-.390524-1.0237 0-1.4142l10.000033-10c.1875-.1875.4419-.2929.7071-.2929.2652 0 .5195.1054.7071.2929L18 19.2525 29.9596 7.29289c.3905-.39052 1.0237-.39052 1.4142 0z" clipRule="evenodd" />
      <path fill={activeColor} d="M21.6666 8c0-.55228.4477-1 1-1h8c.5523 0 1 .44772 1 1v8c0 .5523-.4477 1-1 1s-1-.4477-1-1V9h-7c-.5523 0-1-.44772-1-1z" clipRule="evenodd" />
    </svg>
  );
};
